import { render, staticRenderFns } from "./icfaDetails.vue?vue&type=template&id=2eaa752e"
import script from "./icfaDetails.vue?vue&type=script&lang=js"
export * from "./icfaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderIcfaDetails: require('/home/etienne/AM-frontend/components/HeaderIcfaDetails.vue').default,DiplomesHomePage: require('/home/etienne/AM-frontend/components/DiplomesHomePage.vue').default})
